import register from '@kpsys/angularjs-register';
import {BarcodeScannerService} from './barcode-scanner.service';
import {zxingJsBarcodeScannerFactory} from './zxing-js-barcode-scanner/zxing-js-barcode-scanner.factory';
import type {ScannerSettings} from './barcode-scanner.types';
import {BarcodeFormat} from './barcode-scanner.types';


const defaultScannerSettings: ScannerSettings = {
    allowEmptyResult: false,
    codeFormats: [BarcodeFormat.EAN_13, BarcodeFormat.EAN_8, BarcodeFormat.CODE_39, BarcodeFormat.CODE_128],
    scanHeight: 360,
    scanWidth: 480,
    timeBetweenDecodeInMillis: 500,
    timeBetweenScansInMillis: 500,
    tryHarder: false
}

export default register('portaro.shared.barcode-scanner')
    .constant('DEFAULT_SCANNER_SETTINGS', defaultScannerSettings)
    .service(BarcodeScannerService.serviceName, BarcodeScannerService)
    .factory(zxingJsBarcodeScannerFactory.factoryName, zxingJsBarcodeScannerFactory)
    .name();
